import { render, staticRenderFns } from "./ks-investor-7.vue?vue&type=template&id=9b50cbde"
var script = {}
import style0 from "./ks-investor-7.vue?vue&type=style&index=0&id=9b50cbde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports